export const DashboardActionTypes = {
    API_RESPONSE_SUCCESS: '@@dashboard/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@dashboard/API_RESPONSE_ERROR',

    LIST_DASHBOARD: '@@dashboard/LIST_DASHBOARD',
};